module.exports = __webpack_public_path__ + "static/media/filter-icon-normal.c57e20f4.svg";